import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs: { q: string; a: string; link?: { to: string; label: string } }[] = [
  {
    q: "Wo kann ich heilys Produkte kaufen?",
    a: "heilys Produkte sind ausschließlich über den offiziellen heilys Shop erhältlich. Dort findest du das vollständige Sortiment, aktuelle Produktdetails und die jeweils gültigen Konditionen. heilys.info ist eine unabhängige Informationsseite und verkauft selbst nichts.",
  },
  {
    q: "Was hat sich am heilys Partnerprogramm geändert?",
    a: "heilys hat das Partnerprogramm zum 31.07.2026 umgestellt. Konditionen werden seitdem ausschließlich zentral über den offiziellen Shop geregelt und gelten dort für alle Kunden gleichermaßen.",
  },
  {
    q: "Warum sollte ich über den Partnerlink kaufen?",
    a: "Der Kauf über den Partnerlink verursacht keine Mehrkosten und unterstützt unabhängige Tests, Videos und Erfahrungsberichte von Longevity Hackers – etwa zur heilys Gen30+ Vision, zur AddRed Schreibtischlampe und zu Rotlichttherapie allgemein.",
  },
  {
    q: "Welche heilys Produkte sind besonders interessant?",
    a: "Besonders spannend sind aus unserer Sicht die heilys Gen30+Vision und die AddRed Schreibtischlampe, weil sie unterschiedliche Anwendungsbereiche abdecken: Rotlichttherapie, Nahinfrarot, Bildschirmarbeit, Abendroutine und Longevity. Für großflächige Anwendung gibt es zusätzlich Panels und Wearables.",
  },
  {
    q: "Ist heilys eine gute Alternative zu Mito Light?",
    a: "heilys und Mito Light verfolgen unterschiedliche Produktansätze. heilys ist besonders interessant für Nutzer, die Wert auf Design, Alltagstauglichkeit und bestimmte Spezialanwendungen legen (Vision-Modus, AddRed für den Schreibtisch). Ein direkter Vergleich hängt vom gewünschten Einsatzzweck ab.",
  },
  {
    q: "Wie lange sollte man Rotlicht anwenden?",
    a: "Pro Sitzung sind 10 Minuten der bewährte Richtwert, 1–2× täglich, mit einem Abstand von 30–40 cm zur klassischen Wärmelampe. Bei modernen Rot-/NIR-Panels orientierst du dich an der Herstellerangabe – kompakte Geräte arbeiten oft mit kürzerem Abstand (15–25 cm), weil die Lichtleistung pro Fläche niedriger ist als bei einer reinen Wärmelampe.",
  },
  {
    q: "Was bringt Rotlichttherapie wirklich?",
    a: "Rotlichttherapie wird heute vor allem für zwei Effekte beschrieben: Wärme durch klassisches Infrarotlicht (entspannend bei Verspannungen, Erkältungsbeschwerden, Muskelkater) und photobiologische Reize durch moderne Rot-/Nahinfrarot-LEDs (630–850 nm) für Haut und Regeneration. Belastbare Studien existieren für einzelne Wellenlängen und Anwendungsfelder, sind aber kein Heilversprechen.",
  },
  {
    q: "Ist heilys.info der offizielle heilys Shop?",
    a: "Nein. heilys.info ist eine unabhängige Informationsseite und hat keine direkte Verbindung zum Unternehmen heilys. Wir betreiben keinen eigenen Shop und verkaufen keine Produkte. Bei Käufen über auf dieser Seite verlinkte Partnerlinks kann eine Provision anfallen – für dich bleibt der Preis dabei unverändert.",
  },
  {
    q: "Welche heilys Produkte sind für Einsteiger interessant?",
    a: "Für Einsteiger in die Rotlichttherapie für zuhause eignen sich in der Regel kompakte Geräte oder kleinere Panels, da sie einen überschaubaren Einstieg bieten und einfach zu handhaben sind. Wer gezielte Bereiche wie Gesicht, Nacken oder Gelenke ansprechen möchte, kann mit einer kompakten Lampe oder der Gen30+Vision starten. Für den Schreibtisch ist die AddRed interessant.",
  },
  {
    q: "Worauf sollte man bei Rotlichtgeräten achten?",
    a: "Wichtige Faktoren bei der Auswahl eines Rotlichtgeräts sind der geplante Einsatzbereich, die Größe des Geräts, die Flexibilität im Alltag und die Verarbeitungsqualität. Auch die verwendeten Wellenlängen spielen eine Rolle: Typisch sind 630–660 nm für sichtbares Rotlicht und 810–850 nm für Nahinfrarot. Wir empfehlen, die technischen Angaben im heilys Shop zu vergleichen.",
  },
  {
    q: "Wie schnell liefert heilys nach Deutschland, Österreich und in die Schweiz?",
    a: "heilys versendet nach aktuellem Stand aus Deutschland, wodurch Lieferungen innerhalb Deutschlands in der Regel innerhalb weniger Werktage eintreffen. Für Österreich und die Schweiz kann die Lieferzeit je nach Versandart etwas länger ausfallen. Die genauen Versandoptionen sind direkt im heilys Shop einsehbar.",
  },
  {
    q: "Was ist der Unterschied zwischen Rotlicht und Nahinfrarot bei heilys Geräten?",
    a: "heilys Geräte arbeiten typischerweise mit zwei Wellenlängenbereichen: Sichtbares Rotlicht im Bereich von 630 bis 660 nm wird vor allem für oberflächennahe Anwendungen wie Haut und Gesicht genutzt. Nahinfrarotlicht im Bereich von 810 bis 850 nm ist für das menschliche Auge unsichtbar und dringt tiefer in das Gewebe ein – häufig eingesetzt für Muskeln und Gelenke. Viele heilys Panels und Lampen kombinieren beide Wellenlängen.",
  },
  {
    q: "Wie sind die heilys Gen30 Erfahrungen?",
    a: "Das heilys Gen30+Vision ist ein kompaktes Rotlichtgerät mit 36 Dual-Chip-LEDs, 30 W Leistung und sechs Wellenlängen (630, 660, 670, 810, 830, 850 nm). Erste Erfahrungen fallen positiv aus: Nutzer schätzen vor allem den Vision-Modus mit 670 nm, die kompakte Bauform für gezielte Anwendungen an Gesicht, Nacken, Muskeln und Gelenken sowie die niedrigen EMF-Werte. Für Ganzkörperanwendungen sind größere heilys Panels besser geeignet.",
  },
  {
    q: "Heißt es heilys oder hailys?",
    a: "Die korrekte Schreibweise der Marke ist heilys (mit „ei\"). Häufige Tippfehler wie „hailys\", „heylis\" oder „heilis\" beziehen sich in der Regel auf dieselbe Marke der weCare+ GmbH aus Bielefeld. Auf heilys.info nutzen wir konsequent die offizielle Schreibweise heilys.",
  },
  {
    q: "Kann man Rotlicht bei einer Erkältung anwenden?",
    a: "Rotlicht wird traditionell zur unterstützenden Wärmeanwendung bei Erkältungsbeschwerden eingesetzt – etwa bei verspannter Muskulatur, Druckgefühl im Gesicht oder allgemeinem Wohlbefinden während eines Infekts. Eine ausführliche, faktenbasierte Einordnung zu Anwendung, Dauer und sinnvollen heilys Geräten haben wir auf einer eigenen Seite zusammengestellt.",
    link: { to: "/rotlicht-erkaeltung", label: "Mehr zum Thema Rotlicht bei Erkältung" },
  },
];

const FAQSection = () => (
  <section id="faq" className="py-10 md:py-20">
    <div className="container">
      <h2 className="text-center font-display text-xl font-bold text-foreground sm:text-2xl md:text-3xl">
        Häufige Fragen zu heilys, Produkten &amp; Partnerlink
      </h2>
      <p className="mx-auto mt-2 max-w-2xl text-center text-sm text-muted-foreground md:mt-3 md:text-base">
        Antworten auf die wichtigsten Fragen rund um die Marke heilys, die einzelnen Produktkategorien, die Anwendung von Rotlicht und die Nutzung des Partnerlinks.
      </p>

      <div className="mx-auto mt-6 md:mt-8 max-w-2xl">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-left font-display text-xs sm:text-sm font-semibold text-foreground hover:no-underline py-3 sm:py-4">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-xs sm:text-sm leading-relaxed text-muted-foreground pb-3 sm:pb-4">
                {faq.a}
                {faq.link && (
                  <>
                    {" "}
                    <Link
                      to={faq.link.to}
                      className="font-medium text-primary underline-offset-4 hover:underline"
                    >
                      {faq.link.label} →
                    </Link>
                  </>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FAQSection;
